import { AnimatePresence, useReducedMotion } from 'motion/react'

import { countRefundMethodErrors } from '@/configuration/pages/ConfigurationPage/RefundsConfiguration/helpers'

import RefundMethodChips from './RefundMethodChips/RefundMethodChips'
import RefundMethodContent from './RefundMethodContent/RefundMethodContent'
import RefundMethodHeader from './RefundMethodHeader/RefundMethodHeader'
import { contentAnimation } from './constants'
import * as Styles from './styles'

const RefundMethod = ({
  refundMethod,
  savedRefundMethod,
  isEditable,
  isExpanded,
  onToggleExpanded,
  onChangeEnabled,
  currency,
  languages,
  subscriptionPlan,
  allowInstantTransactions,
  storeCurrencySymbol,
  provider,
  errors,
  onChange,
}) => {
  const shouldReduceMotion = useReducedMotion()

  const transition = { duration: shouldReduceMotion ? 0 : contentAnimation.duration }

  return (
    <Styles.MainContainer>
      <RefundMethodHeader
        refundMethod={refundMethod}
        savedRefundMethod={savedRefundMethod}
        isEditable={isEditable}
        isExpanded={isExpanded}
        onToggleExpanded={onToggleExpanded}
        onChangeEnabled={onChangeEnabled}
        errorCount={errors ? countRefundMethodErrors(errors) : 0}
      />
      <RefundMethodChips refundMethod={refundMethod} currency={currency} />
      <AnimatePresence initial={false}>
        {isExpanded && (
          <Styles.Content
            initial={contentAnimation.collapsed}
            animate={contentAnimation.expanded}
            exit={contentAnimation.collapsed}
            transition={transition}
          >
            <RefundMethodContent
              refundMethod={refundMethod}
              savedRefundMethod={savedRefundMethod}
              languages={languages}
              subscriptionPlan={subscriptionPlan}
              allowInstantTransactions={allowInstantTransactions}
              isEditable={isEditable}
              storeCurrencySymbol={storeCurrencySymbol}
              provider={provider}
              errors={errors}
              onChange={onChange}
            />
          </Styles.Content>
        )}
      </AnimatePresence>
    </Styles.MainContainer>
  )
}

export default RefundMethod
